import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { TableCell, TableRow, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import messages from "../../../assets/locale/messages";
import Table from "../../../components/Table";
import { edit } from "../../../store/ActionsBtn/actions";
import EmptyState from "../../../components/EmptyState";
import TopicsDelete from "./TopicsDelete";
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from "../../../utils/PathsNames";

const TopicsList = ({ lang, isSubTopic }) => {
  const dispatch = useDispatch();
  const { list, subTopicsList } = useSelector(
    (state) => state.flashCardTopics
  );
  const isLoading = useSelector((state) => state.loader);

  const [deleteModal, setDeleteModal] = useState({
    id: 0,
    name: "",
    open: false
  });

  const {
    flashcard: {
      topic: {
        topicNameLabel,
        subTopicsCount,
        flashcardsCount,
        systemCodeLabel
      },
      subTopic: { subTopicNameLabel, subjectCodeLabel }
    }
  } = messages[lang];

  const handleEdit = (id) => dispatch(edit(id));

  const handleDelete = (row) =>
    setDeleteModal({ id: row.id, name: row.name, open: true });

  const currentArr = isSubTopic ? subTopicsList : list;

  return (
    <>
      <Table
        headlines={
          isSubTopic
            ? [subTopicNameLabel, subjectCodeLabel, flashcardsCount]
            : [
                topicNameLabel,
                systemCodeLabel,
                subTopicsCount,
                flashcardsCount
              ]
        }
        hasActions={true}
        rows={currentArr?.map((row) => (
          <TableRow className="table__row" key={row.id}>
            <TableCell className="table__cell" align="left">
              {!isSubTopic ? (
                <Link
                  className="text-decoration-underline text-primary"
                  to={`${ROUTE_PATHS["flashcardTopic"]}/${row.id}/sub-topics`}
                >
                  {row.name}
                </Link>
              ) : (
                <>{row.name}</>
              )}
            </TableCell>
            <TableCell className="table__cell" align="left">
              {!isSubTopic ? row.system_code : row.subject_code}
            </TableCell>
            {!isSubTopic && (
              <TableCell className="table__cell" align="left">
                {row.sub_topics_count}
              </TableCell>
            )}
            <TableCell className="table__cell" align="left">
              {row.flashcards_count}
            </TableCell>

            <TableCell className="table__cell" align="right">
              <IconButton
                onClick={() => handleEdit(row.id)}
                aria-label="edit"
              >
                <EditIcon className="table__edit" fontSize="medium" />
              </IconButton>
              <IconButton
                aria-label="delete"
                onClick={() => handleDelete(row)}
              >
                <DeleteIcon
                  className="table__delete"
                  fontSize="medium"
                />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      />

      {!isLoading && !currentArr.length && <EmptyState />}

      <TopicsDelete
        isSubTopic={isSubTopic}
        lang={lang}
        id={deleteModal.id}
        isOpen={deleteModal.open}
        nameTopicOrSubTopic={deleteModal.name}
        setDeleteModal={setDeleteModal}
      />
    </>
  );
};

TopicsList.propTypes = {
  isSubTopic: PropTypes.bool.isRequired,
  lang: PropTypes.string
};

export default TopicsList;
